var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThreeDot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "15px",
    viewBox: "0 0 5 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 1144") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1144",
    fill: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.875,3.75 C3.90875,3.75 4.75,2.90875 4.75,1.875 C4.75,0.84125 3.90875,0 2.875,0 C1.84125,0 1,0.84125 1,1.875 C1,2.90875 1.84125,3.75 2.875,3.75",
    id: "Fill-1042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.875,5.625 C1.84125,5.625 1,6.46625 1,7.5 C1,8.53375 1.84125,9.375 2.875,9.375 C3.90875,9.375 4.75,8.53375 4.75,7.5 C4.75,6.46625 3.90875,5.625 2.875,5.625",
    id: "Fill-1043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75,11.25 C1.64733333,11.25 0.75,12.09125 0.75,13.125 C0.75,14.15875 1.64733333,15 2.75,15 C3.85266667,15 4.75,14.15875 4.75,13.125 C4.75,12.09125 3.85266667,11.25 2.75,11.25",
    id: "Fill-1044"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThreeDot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/three-dot.6b7206f10bc429a096577fa44f66bfe0.svg";